import React from "react";
import { Outlet } from "react-router-dom";

import FeedbackModal from "../components/FeedbackModal";
import PnlSubmitModal from "../components/assetManager/PnlSubmitModal";
import { AssetManagerWorkspaceProvider, useAssetManagerWorkspace } from "../hooks/useAssetManagerWorkspace";

function AssetManagerFeedback() {
  const { pnlSubmitSuccess, setPnlSubmitSuccess } = useAssetManagerWorkspace();
  return (
    <FeedbackModal
      open={Boolean(pnlSubmitSuccess)}
      title={pnlSubmitSuccess?.title || "P&L submitted"}
      onClose={() => setPnlSubmitSuccess(null)}
    >
      {pnlSubmitSuccess ? (
        <>
          <p style={{ margin: "0 0 8px", lineHeight: 1.5 }}>
            <strong>{pnlSubmitSuccess.projectName}</strong>
          </p>
          <p style={{ margin: "0 0 8px", lineHeight: 1.5 }}>
            Net P&amp;L: <strong>{pnlSubmitSuccess.netPnlLabel}</strong>
          </p>
          <p className="muted" style={{ margin: 0, fontSize: 13, lineHeight: 1.45 }}>
            {pnlSubmitSuccess.message}
          </p>
        </>
      ) : null}
    </FeedbackModal>
  );
}

export default function AssetManagerLayout() {
  return (
    <AssetManagerWorkspaceProvider>
      <Outlet />
      <PnlSubmitModal />
      <AssetManagerFeedback />
    </AssetManagerWorkspaceProvider>
  );
}
